import {
    Card,
    Divider,
    Grid,
    Typography,
    Button,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Container,
    Drawer,
} from '@mui/material'
import { Box } from '@mui/system'
import moment from 'moment'

function RenewSubscriptionDrawer({
    title,
    onSubmit,
    entitlementData,
    visible,
    onClose,
    currentPlan,
    calculationData,
}) {

    if (calculationData == undefined) {
        calculationData = {
            subtotal: 0,
            total: 0,
            net_amount: 0,
        }
    }

    return (
        <div>
            <Drawer
                anchor="right"
                backdrop="static"
                variant="temporary"
                open={visible}
                onClose={onClose}
                PaperProps={{
                    sx: {
                        width: {
                            lg: 400,
                            md: 300,
                        }
                    }
                }}
            >
                <Container sx={{ padding: 5 }}>
                    <Box sx={{ textAlign: "center" }} >
                        <Typography
                            style={{ fontSize: 14, fontWeight: 'bold', marginTop: 5 }}
                            gutterBottom
                        >
                            {title}
                        </Typography>
                        <Divider spacing={10} />
                    </Box>
                    <Grid container spacing={6} >
                        <Grid item md={6}>
                            <Typography size="small" style={{ fontSize: 14, paddingTop: 15 }} gutterBottom>
                                No of users : {entitlementData?.max_users}
                            </Typography>
                        </Grid>
                        <Grid item md={6}>
                            <Typography style={{ fontSize: 14, paddingTop: 15 }} gutterBottom>
                                Purchase Type : Renew
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={6} style={{ paddingLeft: 2 }}>
                        <Grid item >
                            <Typography
                                style={{
                                    marginTop: 8,
                                    fontSize: 14,
                                    fontWeight: 'bold',
                                }}
                            >
                                Plan Expiry : {moment(new Date(entitlementData?.expiry_date)).format("DD-MM-YYYY")}

                            </Typography>
                        </Grid>
                    </Grid>
                    <Card style={{ marginTop: 15 }}>
                        <Table size="small" >
                            <TableHead>
                                <TableRow>
                                    <TableCell>Plan Name</TableCell>
                                    <TableCell>Fixed Price</TableCell>
                                    <TableCell align="left"> Qty</TableCell>
                                    <TableCell align="left"> Unit Price</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell align="left" style={{ fontWeight: 'bold' }}>
                                        {entitlementData?.current_plan?.name}
                                    </TableCell>
                                    <TableCell align="left">Rs {currentPlan?.fixed_charge}</TableCell>
                                    <TableCell align="left"> {entitlementData?.max_users}</TableCell>
                                    <TableCell align="left">Rs {currentPlan?.price_per_user}</TableCell>
                                </TableRow>
                            </TableBody>
                            <TableBody>
                                <TableRow>
                                    <TableCell rowSpan={7} />
                                    <TableCell colSpan={2} style={{ fontWeight: 'bold' }}>
                                        Subtotal
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: 'bold' }}>
                                        {calculationData.subtotal}
                                    </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell colSpan={2} style={{ fontWeight: 'bold' }}>
                                        GST
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: 'bold' }}>
                                        {currentPlan?.igst} %
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={2} style={{ fontWeight: 'bold' }}>
                                        Total
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: 'bold' }}>
                                        {calculationData.total}{' '}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={2} style={{ fontWeight: 'bold' }}>
                                        Credit Amount
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: 'bold' }}>
                                        {entitlementData.credit_note}{' '}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={2} style={{ fontWeight: 'bold' }}>
                                        Net Amount
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: 'bold' }}>
                                        {calculationData.net_amount}{' '}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Card>
                    <Grid container spacing={6} style={{ paddingTop: 20 }}>
                        <Grid item md={12}>
                            <Button
                                onClick={() => onSubmit()}
                                style={{ width: '28%' }}
                                variant="contained"
                                size="small"
                                color="primary"
                                mt={3}
                            >
                                Pay {calculationData.net_amount}
                            </Button>

                        </Grid>
                    </Grid>

                </Container>
            </Drawer>
        </div>
    )
}

export default RenewSubscriptionDrawer